<script lang="ts" setup>
const props = defineProps({
  name: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <div class="tag"># {{ props.name }}</div>
</template>

<style lang="scss" scoped>
.tag {
  padding: toRem(5) toRem(12);
  border: 1px solid $color-gray-line;
  font-size: toRem(14);
  font-weight: 400;
  color: $color-gray-1;
}
</style>
